var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authorization !== null)?_c('div',{staticClass:"authorization-status",class:{
    'success-status': _vm.authorization.status === 'SUCCEEDED',
    'failure-status': _vm.authorization.status === 'FAILED',
    'canceled-status': ['CANCELED', 'UNAVAILABLE'].includes(_vm.authorization.status),
    'progress-status': _vm.authorization.status === 'PENDING'
  }},[_vm._v(" "+_vm._s(_vm.$t('authorizations.status.' + _vm.authorization.status))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }